<p-header
  *ngIf="!hideLayout"
  [isUserInfoDisplayed]="!isConnexionPage"
></p-header>
<div [class.container]="!hideLayout">
  <router-outlet></router-outlet>
</div>
<p-footer
  *ngIf="!hideLayout"
  [isCguDisplayed]="!isConnexionPage"
  [isDpoDisplayed]="!isConnexionPage"
></p-footer>
